import classnames from 'classnames';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { useIsOnline } from '../utils/InternetConnectionProvider';

import Ripple from '../utils/Ripple';
import Spinner from '../utils/Spinner';

import styles from './Submit.scss';

export default function Submit({
  label,
  buttonStyle,
  disabled,
  block,
  formElement,
  align,
  onClick,
  isSubmitting,
  className: propsClassName,
}) {
  let className = 'btn-primary';
  switch (buttonStyle) {
    case 'dark':
      className = 'bg-indigo-400';
      break;
    default:
      break;
  }

  const { isOnline } = useIsOnline();

  return (
    <div className={classnames(`text-${align}`, { 'form-group': formElement })}>
      <Ripple>
        <button
          className={classnames(
            'btn',
            { 'btn-block': block },
            styles.button,
            className,
            propsClassName,
          )}
          disabled={!isOnline || disabled || isSubmitting}
          title={_.isString(label) && label}
          type="submit"
          onClick={onClick}
        >
          {isSubmitting ? <Spinner inline /> : label}
        </button>
      </Ripple>
    </div>
  );
}

Submit.propTypes = {
  disabled: PropTypes.bool,
  block: PropTypes.bool,
  buttonStyle: PropTypes.oneOf(['default', 'dark']),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  formElement: PropTypes.bool,
  align: PropTypes.oneOf(['left', 'right', 'center']),
  onClick: PropTypes.func,
  className: PropTypes.string,
  isSubmitting: PropTypes.bool,
};
Submit.defaultProps = {
  block: false,
  disabled: false,
  buttonStyle: 'default',
  align: 'right',
  onClick: null,
  formElement: false,
  className: null,
  isSubmitting: false,
};
